__turbopack_context__.v({
  "buttonWrp": "loginModal-module-scss-module__MGZ4NG__buttonWrp",
  "explanation": "loginModal-module-scss-module__MGZ4NG__explanation",
  "featuresWrp": "loginModal-module-scss-module__MGZ4NG__featuresWrp",
  "modalWrp": "loginModal-module-scss-module__MGZ4NG__modalWrp",
  "titleWrp": "loginModal-module-scss-module__MGZ4NG__titleWrp",
});
